// for public
var param = {};
param.NUMBER_OF_WEEKS = 15;
param.SALVAGE_VALUE = 25;
param.INITIAL_INVENTORY = 2000;
param.PRICE = [0, 60, 54, 48, 36];
param.PRICE_LABEL = ['', 'Full', '10%', '20%', '40%'];
param.NUM_ROUNDS = 5;
param.IS_FIXED_WEEKONE = true;
param.PRICE_NEW = [60, 54, 48, 36];
param.PRICE_LABEL_NEW = ['Full', '10%', '20%', '40%'];
module.exports = param;


// WEBPACK FOOTER //
// ../public/js/params_public.js